'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _actionTypes = require('../constants/action-types');

var _update = require('../lib/update');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var initialState = {};

var withoutPath = function withoutPath(state, path) {
    var _path = _toArray(path),
        key = _path[0],
        restPath = _path.slice(1);

    if (restPath.length) {
        return _extends({}, state, _defineProperty({}, key, withoutPath(state[key], restPath)));
    } else {
        return (0, _lodash2.default)(state, key);
    }
};

var entities = function entities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === _actionTypes.RESET) {
        return 'entities' in action ? action.entities : initialState;
    } else if (action.type === _actionTypes.MUTATE_START && action.optimisticEntities) {
        return _extends({}, state, action.optimisticEntities);
    } else if (action.type === _actionTypes.MUTATE_FAILURE && action.rolledBackEntities) {
        return _extends({}, state, action.rolledBackEntities);
    } else if (action.type === _actionTypes.REQUEST_SUCCESS || action.type === _actionTypes.MUTATE_SUCCESS) {
        return _extends({}, state, action.entities);
    } else if (action.type === _actionTypes.UPDATE_ENTITIES) {
        return _extends({}, state, (0, _update.optimisticUpdateEntities)(action.update, state));
    } else {
        return state;
    }
};

exports.default = entities;


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-query/dist/commonjs/reducers/entities.js
 ** module id = 313
 ** module chunks = 3
 **/